export default {
    methods: {
        $_getPaymentLogoPath: (paymentMethod) => {
            return `/images/payment-logos/${paymentMethod}.png`;
        },
        $_getInvoiceLogoPath: (paymentMethod) => {
            return `/images/invoice/${paymentMethod}.png`;
        },
    },
}
